import React, { useEffect, useState } from "react";
import styles from "./advance.module.scss";
import { useHistory } from "react-router-dom";
import { Dialog } from "primereact/dialog";
import { toast } from "react-toastify";
import PurchaseInvoiceDialog from "../billing/PurchaseInvoiceDialog";

function InvoiceAdvance() {
    const history = useHistory();
    const role = localStorage.getItem("role");
    const [showPurchaseDialog, setShowPurchaseDialog] = useState(false);

    useEffect(() => {
        // Check if the page has already been refreshed in this session
        const isRefreshed = sessionStorage.getItem("isRefreshed");

        if (!isRefreshed) {
            // Set the flag in sessionStorage to indicate the page has been refreshed
            sessionStorage.setItem("isRefreshed", "true");
            // Refresh the page
            window.location.reload();
        }
        else if(isRefreshed)
            {
                sessionStorage.removeItem("isRefreshed");
            }
    }, []);
    return (
        <div className={styles.pageContainer}>
            <div className={styles.header}>
                <h1>Invoices</h1>
                <p>Review, collect, and track every invoice in one place</p>
            </div>
            <div className={styles.cardsGrid}>
                <div className={`${styles.featureBlock} ${styles.pending}`} onClick={() => history.push("/invoice/pending")}>
                    <div className={styles.featureIcon}>
                        <i className="pi pi-clock" />
                    </div>
                    <div className={styles.featureText}>
                        <p className={styles.featureTitle}>Pending Review</p>
                        <span className={styles.featureDesc}>Invoices awaiting approval</span>
                    </div>
                    <i className={`pi pi-angle-right ${styles.featureArrow}`} />
                </div>
                <div className={`${styles.featureBlock} ${styles.unpaid}`} onClick={() => history.push("/invoice/unpaid")}>
                    <div className={styles.featureIcon}>
                        <i className="pi pi-wallet" />
                    </div>
                    <div className={styles.featureText}>
                        <p className={styles.featureTitle}>Unpaid Invoices</p>
                        <span className={styles.featureDesc}>Reviewed and awaiting payment</span>
                    </div>
                    <i className={`pi pi-angle-right ${styles.featureArrow}`} />
                </div>
                <div className={`${styles.featureBlock} ${styles.partial}`} onClick={() => history.push("/invoice/partial")}>
                    <div className={styles.featureIcon}>
                        <i className="pi pi-percentage" />
                    </div>
                    <div className={styles.featureText}>
                        <p className={styles.featureTitle}>Partially Paid Invoices</p>
                        <span className={styles.featureDesc}>Some payment received, balance still owed</span>
                    </div>
                    <i className={`pi pi-angle-right ${styles.featureArrow}`} />
                </div>
                <div className={`${styles.featureBlock} ${styles.paid}`} onClick={() => history.push("/invoice/paid")}>
                    <div className={styles.featureIcon}>
                        <i className="pi pi-check-circle" />
                    </div>
                    <div className={styles.featureText}>
                        <p className={styles.featureTitle}>Paid Invoices</p>
                        <span className={styles.featureDesc}>Completed and settled</span>
                    </div>
                    <i className={`pi pi-angle-right ${styles.featureArrow}`} />
                </div>
                {role === "admin" && (
                    <div className={`${styles.featureBlock} ${styles.recordPayment}`} onClick={() => setShowPurchaseDialog(true)}>
                        <div className={styles.featureIcon}>
                            <i className="pi pi-shopping-cart" />
                        </div>
                        <div className={styles.featureText}>
                            <p className={styles.featureTitle}>New Purchase Invoice</p>
                            <span className={styles.featureDesc}>Bill a client for goods bought on their behalf</span>
                        </div>
                        <i className={`pi pi-angle-right ${styles.featureArrow}`} />
                    </div>
                )}
                {role === "admin" && (
                    <div className={`${styles.featureBlock} ${styles.recordPayment}`} onClick={() => history.push("/client-payment")}>
                        <div className={styles.featureIcon}>
                            <i className="pi pi-money-bill" />
                        </div>
                        <div className={styles.featureText}>
                            <p className={styles.featureTitle}>Record Payment</p>
                            <span className={styles.featureDesc}>Apply a wire transfer to outstanding invoices</span>
                        </div>
                        <i className={`pi pi-angle-right ${styles.featureArrow}`} />
                    </div>
                )}
                {role === "admin" && (
                    <div className={`${styles.featureBlock} ${styles.recordPayment}`} onClick={() => history.push("/admin/client-payments")}>
                        <div className={styles.featureIcon}>
                            <i className="pi pi-history" />
                        </div>
                        <div className={styles.featureText}>
                            <p className={styles.featureTitle}>Payment History</p>
                            <span className={styles.featureDesc}>Audit trail of every recorded payment</span>
                        </div>
                        <i className={`pi pi-angle-right ${styles.featureArrow}`} />
                    </div>
                )}
            </div>
            <Dialog visible={showPurchaseDialog} header="New Purchase Invoice" style={{ width: "720px", maxWidth: "95vw" }} contentStyle={{ overflowX: "hidden" }} onHide={() => setShowPurchaseDialog(false)}>
                <PurchaseInvoiceDialog
                    onHideDialog={() => setShowPurchaseDialog(false)}
                    onsuccess={(invoice) => {
                        setShowPurchaseDialog(false);
                        toast.success(`Purchase invoice ${invoice?.invoiceId || ""} created`);
                    }}
                />
            </Dialog>
        </div>
    );
}

export default InvoiceAdvance;
